/* eslint-disable import/prefer-default-export */
import api from "./axios";

export async function getAuth(token) {
  try {
    const response = await api.get(`/auth/email/verify?token=${token}`);

    // Store the session token in local storage
    localStorage.setItem("sessionToken", response.data.token);

    // Redirect the user to their dashboard or another page
    /* window.location.href = "/accueil"; */

    return response;
  } catch (error) {
    // Handle any errors (e.g., invalid or expired token)
    console.error("Error verifying token:", error);
    // Optionally, handle the error more gracefully in the UI
    // For example, show an error message to the user
  }
}

export async function postAuth(email) {
  const response = await api.post("/auth/email/send", email);
  return response;
}

// Nouvelle fonction de connexion avec username/password
export async function postLogin(credentials) {
  const response = await api.post("/auth/login", credentials);
  return response;
}

// Fonction pour changer le mot de passe (admin seulement)
export async function changePassword(userId, newPassword) {
  const response = await api.put("/auth/change-password", {
    user_id: userId,
    new_password: newPassword
  });
  return response;
}

/* export async function deleteAbsence(absenceId) {
  const response = await absences.delete(`/${absenceId}`);
  return response;
}

export async function putAbsence(absence, absenceId) {
  const response = await absences.put(`/${absenceId}`, absence);
  return response;
} */
